import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Careers.css';

const Careers = () => {
  return (
    <>
      <Helmet>
        <title>Careers - Join Redbox Global | Work With Us</title>
        <meta name="description" content="Explore career opportunities at Redbox Global. Join a dynamic team delivering business and financial information news and insights around the world." />
        <meta name="keywords" content="Redbox Global careers, jobs, employment, work with us, career opportunities, financial news jobs, journalism careers" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/careers" />
        <meta property="og:title" content="Careers - Join Redbox Global | Work With Us" />
        <meta property="og:description" content="Explore career opportunities at Redbox Global. Join a dynamic team delivering business and financial information around the world." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/careers" />
        <meta name="twitter:title" content="Careers - Join Redbox Global | Work With Us" />
        <meta name="twitter:description" content="Explore career opportunities at Redbox Global. Join our team of talented professionals." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/careers" />
      </Helmet>
      
      <div className="page-container">
      <div className="page-header">
        <h1>Careers</h1>
        <p className="page-subtitle">Join our team and shape the future of business news and information</p>
      </div>
      
      <div className="page-content">
        <a href="/article/life-at-redbox-global" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div className="featured-article">
            <div className="featured-image">
              <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&h=600&fit=crop" alt="Redbox Global Team" />
            </div>
            <div className="featured-content">
              {/* <span className="article-category">Featured Story</span> */}
              <h2>Life at Redbox Global: Where Innovation Meets Impact</h2>
              <p>Discover what makes Redbox Global a great place to work. From our commitment to diversity and inclusion to cutting-edge technology and global opportunities, learn how our team is shaping the future of financial information.</p>
              <span className="article-meta">Career Spotlight</span>
            </div>
          </div>
        </a>

        <div className="content-grid">
          <a href="/article/open-positions-engineering" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=600&h=400&fit=crop" alt="Engineering Careers" />
              </div>
              <div className="article-content">
                {/* <span className="article-category">Engineering</span> */}
                <h2>Software Engineers: Build Tomorrow's Financial Platform</h2>
                <p>Join our engineering team to develop cutting-edge solutions that power real-time financial data and news delivery to millions of users worldwide.</p>
                <span className="article-meta">View Open Positions</span>
              </div>
            </article>
          </a>

          <a href="/article/journalism-opportunities" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=600&h=400&fit=crop" alt="Journalism Careers" />
              </div>
              <div className="article-content">
                {/* <span className="article-category">Editorial</span> */}
                <h2>Journalists & Reporters: Tell Stories That Matter</h2>
                <p>Become part of our award-winning newsroom covering markets, economics, politics, and technology with accuracy and speed.</p>
                <span className="article-meta">Explore Roles</span>
              </div>
            </article>
          </a>

          <a href="/article/diversity-inclusion-initiatives" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=600&h=400&fit=crop" alt="Diversity & Inclusion" />
              </div>
              <div className="article-content">
                {/* <span className="article-category">Culture</span> */}
                <h2>Diversity & Inclusion: Building a Better Workplace</h2>
                <p>Learn about our commitment to creating an inclusive environment where diverse perspectives drive innovation and excellence.</p>
                <span className="article-meta">Learn More</span>
              </div>
            </article>
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default Careers;
